jQuery(document).ready(function($) {

	var $tabs = $('.page-tabs:not(.page-tabs--video) a');
	var $sections = $('.project-page__section:not(:nth-child(2))');

	$sections.css('display', 'none');

	if ($sections.length) {
		var targetTab = window.location.hash;

		var $tabTrigger = $('a[href="' + targetTab + '"]');

		if (targetTab) {
			changeTab($tabTrigger, $('.project-page__section--active'), targetTab, true);
		}
	}
	
	$tabs.on('click', function(event) {

		event.preventDefault();

		var target = $(this)[0].hash;
		
		changeTab($(this), $('.project-page__section--active'), target, false);
		
	});

	function changeTab($trigger, $currentSection, target, onLoad) {
		// var $currentSection = $('.project-page__section--active');
		var $newSection = $(target + '-tab');

		$tabs.removeClass('selected');
		$trigger.addClass('selected');

		if (!onLoad) {
			var newUrl = window.location.origin + window.location.pathname + target;
			window.history.pushState({}, null, newUrl);
		}
		
		$currentSection.removeClass('project-page__section--active').fadeOut(400, function () {
			$newSection.addClass('project-page__section--active').fadeIn();
		});
	}

	window.addEventListener('popstate', function (event) {

		if ($sections.length) {
			var targetTab = window.location.hash;
			var $tabTrigger = $('a[href="' + targetTab + '"]');

			if (targetTab) {
				changeTab($tabTrigger, $('.project-page__section--active'), targetTab, true);
			}
		}
		
	}, false);
});